import { Locales } from 'src/lib/constants';
import { getBlogPagePaths, getBlogPageProps } from 'src/lib/blog-page-data';
import BlogPagedPage from 'src/components/Blog/Pages/BlogPagedPage';

export const getStaticPaths = () => {
  return getBlogPagePaths({ locale: Locales.EN_EU });
};

export const getStaticProps = ({ params }) => {
  return getBlogPageProps({ locale: Locales.EN_EU, page: params.page });
};

export default BlogPagedPage;
